var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-none", attrs: { id: "scans" } },
    [
      _c("navbar-main", {
        attrs: { verifiedAccount: _vm.verifiedAccount },
        on: { updateModal: _vm.updateModal },
      }),
      _vm._v(" "),
      _c("page-header", {
        attrs: { title: "Report overview", links: _vm.breadcrumbsLinks },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "scans-card card",
            _vm.$mq !== "desktop" && _vm.$mq !== "laptop" && "page-mobile",
          ],
        },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "loading-container" }, [_vm._m(0)])
            : !_vm.isLoading && (_vm.$mq === "desktop" || _vm.$mq === "laptop")
            ? _c("div", [
                _vm.$mq === "desktop" || _vm.$mq === "laptop"
                  ? _c(
                      "table",
                      {
                        class: [
                          "scan-overview",
                          "dashboard-revamped",
                          (_vm.$mq === "desktop" || _vm.$mq === "laptop") &&
                            _vm.isLoading &&
                            "table-loading",
                        ],
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._l(_vm.scans, function (label, labelIndex) {
                          return _c(
                            "tbody",
                            { key: label },
                            _vm._l(label.scans, function (scan, index) {
                              return scan.label === label.label
                                ? _c(
                                    "tr",
                                    {
                                      key: index,
                                      staticClass: "normal",
                                      class: {
                                        unpublished: scan.unpublished,
                                        hidden:
                                          _vm.focusedScanIndex !== labelIndex &&
                                          index !== 0,
                                      },
                                    },
                                    [
                                      label.newest_iteration == scan.scan_num &&
                                      index == 0
                                        ? _c(
                                            "td",
                                            {
                                              staticClass: "name",
                                              attrs: {
                                                rowspan: label.scans.length,
                                              },
                                            },
                                            [
                                              scan.scan_id != null
                                                ? _c(
                                                    "span",
                                                    { staticClass: "label" },
                                                    [
                                                      label.scans.length ===
                                                        1 ||
                                                      _vm.focusedScanIndex !==
                                                        labelIndex
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              style: {
                                                                visibility:
                                                                  label.scans
                                                                    .length > 1
                                                                    ? "visible"
                                                                    : "hidden",
                                                              },
                                                              attrs: {
                                                                icon: [
                                                                  "far",
                                                                  "chevron-circle-right",
                                                                ],
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setFocusedScanIndex(
                                                                      labelIndex
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          )
                                                        : _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: [
                                                                  "far",
                                                                  "chevron-circle-down",
                                                                ],
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.setFocusedScanIndex(
                                                                      null
                                                                    )
                                                                  },
                                                              },
                                                            }
                                                          ),
                                                      _vm._v(" "),
                                                      scan.scan_id != null
                                                        ? _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold label-link",
                                                              class:
                                                                _vm.setBreakWord(
                                                                  scan.label
                                                                ),
                                                              attrs: {
                                                                href:
                                                                  "/report?scan_id=" +
                                                                  scan.scan_id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                    " +
                                                                  _vm._s(
                                                                    scan.label
                                                                  ) +
                                                                  "\n                                "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _c("strong", [
                                                    _vm._v(
                                                      "\n                                " +
                                                        _vm._s(scan.label) +
                                                        "\n                            "
                                                    ),
                                                  ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "integrations" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "scan-integrations",
                                            },
                                            _vm._l(
                                              scan.integrations,
                                              function (integration) {
                                                return _c("img", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value:
                                                        _vm.integrationScanInfo(
                                                          integration
                                                        ),
                                                      expression:
                                                        "integrationScanInfo(integration)",
                                                    },
                                                  ],
                                                  key:
                                                    "integration_" +
                                                    integration +
                                                    "_" +
                                                    scan.scan_id,
                                                  staticClass:
                                                    "integration-icons",
                                                  class: integration + "-icon",
                                                  attrs: {
                                                    src: _vm
                                                      .integrationLogoPath[
                                                      integration
                                                    ],
                                                  },
                                                })
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !scan.finished && scan.canceled
                                        ? _c("td", {
                                            staticClass:
                                              "scan-number text-right font-weight-bold",
                                          })
                                        : _c(
                                            "td",
                                            {
                                              staticClass:
                                                "scan-number text-right font-weight-bold",
                                            },
                                            [
                                              scan.scan_id != null
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass: "revision",
                                                      attrs: {
                                                        href:
                                                          "/report?scan_id=" +
                                                          scan.scan_id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            scan.scan_num
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-info revision",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                " +
                                                          _vm._s(
                                                            scan.scan_num
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      !scan.finished && scan.canceled
                                        ? _c("td", {
                                            staticClass: "date-started",
                                            class: {
                                              unpublished: scan.unpublished,
                                            },
                                            attrs: {
                                              title: _vm._f("niceStarted")(
                                                scan.started
                                              ),
                                            },
                                          })
                                        : _c(
                                            "td",
                                            {
                                              staticClass: "date-started",
                                              class: {
                                                unpublished: scan.unpublished,
                                              },
                                              attrs: {
                                                title: _vm._f("niceStarted")(
                                                  scan.started
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm._f("dateFinish")([
                                                      scan.started,
                                                      _vm.timestamp,
                                                      scan.status,
                                                      scan.finished,
                                                    ])
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      scan.finished
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "status-processing text-info",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "/report?scan_id=" +
                                                      scan.scan_id,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "nowrap" },
                                                    [_vm._v("Completed")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : !scan.finished && scan.canceled
                                        ? _c(
                                            "td",
                                            { staticClass: "canceled-status" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: `${_vm.canceledScanInfo(
                                                        scan
                                                      )} on ${_vm.convertOpochToDate(
                                                        scan.canceled
                                                      )}`,
                                                      expression:
                                                        "`${canceledScanInfo(scan)} on ${convertOpochToDate(scan.canceled)}`",
                                                    },
                                                  ],
                                                  staticClass: "text-disabled",
                                                  attrs: {
                                                    href:
                                                      "/report?scan_id=" +
                                                      scan.scan_id,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "nowrap" },
                                                    [_vm._v("Cancelled")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "td",
                                            {
                                              staticClass:
                                                "status-processing text-info",
                                              class: {
                                                unpublished: scan.unpublished,
                                              },
                                              attrs: {
                                                title: _vm._f("niceStarted")(
                                                  scan.started
                                                ),
                                              },
                                            },
                                            [
                                              scan.scan_id != null
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "/report?scan_id=" +
                                                          scan.scan_id,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "nowrap",
                                                        },
                                                        [_vm._v("In Progress")]
                                                      ),
                                                    ]
                                                  )
                                                : _c("div", [
                                                    _c(
                                                      "span",
                                                      { staticClass: "nowrap" },
                                                      [_vm._v("In Progress")]
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      scan.finished
                                        ? _c("td", { staticClass: "report" }, [
                                            _c(
                                              "div",
                                              { staticClass: "stats" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "stat",
                                                    attrs: {
                                                      title:
                                                        scan.num_ips +
                                                        " IPs & domains",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm._f("niceNumber")(
                                                            scan.num_ips
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "stat" },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm._f("niceNumber")(
                                                            scan.num_major
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "stat" },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm._f("niceNumber")(
                                                            scan.num_noteworthy
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "stat" },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm._f("niceNumber")(
                                                            scan.num_minor
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : scan.canceled
                                        ? _c("td", {
                                            staticClass: "report-processing",
                                          })
                                        : _c(
                                            "td",
                                            {
                                              staticClass: "report-processing",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "progress mr-3",
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "progress-bar",
                                                        style: {
                                                          width:
                                                            Math.floor(
                                                              scan.status * 100
                                                            ) + "%",
                                                        },
                                                        attrs: {
                                                          role: "progressbar",
                                                          "aria-valuenow":
                                                            _vm._f(
                                                              "percentDone"
                                                            )(scan.status),
                                                          "aria-valuemin": "0",
                                                          "aria-valuemax":
                                                            "100",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm._f("percentDone")(
                                                            scan.status
                                                          )
                                                        ) +
                                                        "% complete\n                                "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _vm.checkIfDemoScan(scan.scan_id)
                                        ? _c("td", { staticClass: "actions" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "scan-actions disabled",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      role: "button",
                                                      "aria-haspopup": "true",
                                                      "aria-expanded": "false",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        $event.stopPropagation()
                                                        return _vm.downloadReport(
                                                          scan.scan_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "download",
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "file-download",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                                        Download\n                                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("a", [
                                                  _c(
                                                    "span",
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass: "fa",
                                                        attrs: {
                                                          icon: ["far", "redo"],
                                                        },
                                                      }),
                                                      _vm._v(
                                                        "\n                                        Rescan\n                                    "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("a", [
                                                  _c(
                                                    "span",
                                                    { staticClass: "delete" },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        staticClass: "fa",
                                                        attrs: {
                                                          icon: [
                                                            "far",
                                                            "trash",
                                                          ],
                                                        },
                                                      }),
                                                      _vm._v("Delete"),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ])
                                        : scan.finished
                                        ? _c("td", { staticClass: "actions" }, [
                                            _c(
                                              "div",
                                              { staticClass: "scan-actions" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      role: "button",
                                                      "aria-haspopup": "true",
                                                      "aria-expanded": "false",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        $event.stopPropagation()
                                                        return _vm.downloadReport(
                                                          scan.scan_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "download",
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "file-download",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                                        Download\n                                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/create?scan_id=" +
                                                        scan.scan_id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "redo",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                                        Rescan\n                                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.prompt(
                                                          scan.scan_id,
                                                          "delete"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "delete" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "trash",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                                        Delete\n                                    "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : scan.canceled
                                        ? _c("td", { staticClass: "actions" }, [
                                            _c(
                                              "div",
                                              { staticClass: "scan-actions" },
                                              [
                                                _c("a"),
                                                _vm._v(" "),
                                                _c("a"),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.prompt(
                                                          scan.scan_id,
                                                          "delete"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "delete" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "trash",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v("Delete"),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _c("td", { staticClass: "actions" }, [
                                            _c(
                                              "div",
                                              { staticClass: "scan-actions" },
                                              [
                                                scan.scan_id != null
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "scan-progress-link",
                                                        attrs: {
                                                          href:
                                                            "/report?scan_id=" +
                                                            scan.scan_id,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          [
                                                            _c(
                                                              "font-awesome-icon",
                                                              {
                                                                staticClass:
                                                                  "fa",
                                                                attrs: {
                                                                  icon: [
                                                                    "far",
                                                                    "eye",
                                                                  ],
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(
                                                              " See Preview"
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("a"),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.prompt(
                                                          scan.scan_id,
                                                          "cancel"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "cancel" },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "fa",
                                                            attrs: {
                                                              icon: [
                                                                "far",
                                                                "times-circle",
                                                              ],
                                                            },
                                                          }
                                                        ),
                                                        _vm._v("Cancel"),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
              ])
            : _c(
                "div",
                { staticClass: "mobile-container" },
                _vm._l(_vm.scans, function (label) {
                  return _c(
                    "div",
                    { key: label, staticClass: "scan-card" },
                    [
                      _c("div", { staticClass: "row font-weight-bold title" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(label.label) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._m(2, true),
                      _vm._v(" "),
                      _vm._l(label.scans, function (scan, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "normal" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "scan-number text-center font-weight-bold col-2",
                                },
                                [
                                  scan.finished
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/report?scan_id=" + scan.scan_id,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(scan.scan_num) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _c("span", { staticClass: "text-info" }, [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(scan.scan_num) +
                                            "\n                            "
                                        ),
                                      ]),
                                ]
                              ),
                              _vm._v(" "),
                              scan.finished
                                ? _c("div", { staticClass: "report col-6" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "row",
                                        attrs: {
                                          href:
                                            "/report?scan_id=" + scan.scan_id,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 major text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("niceNumber")(
                                                    scan.num_major
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 noteworthy text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("niceNumber")(
                                                    scan.num_noteworthy
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 minor text-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("niceNumber")(
                                                    scan.num_minor
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "report-processing col-6" },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "text-info" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("percentDone")(
                                                    scan.status
                                                  )
                                                ) +
                                                "% complete\n                                "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                              _vm._v(" "),
                              scan.finished
                                ? _c("div", { staticClass: "actions col-4" }, [
                                    _c(
                                      "ul",
                                      { staticClass: "nav mobile-actions row" },
                                      [
                                        _c(
                                          "li",
                                          { staticClass: "nav-item col-4" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "nav-link-mobile text-dark",
                                                attrs: {
                                                  href:
                                                    "/downloads/xlsx?scan_id=" +
                                                    scan.scan_id,
                                                  role: "button",
                                                  "aria-haspopup": "true",
                                                  "aria-expanded": "false",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-download icon-mobile",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          { staticClass: "nav-item col-4" },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "nav-link-mobile text-dark",
                                                attrs: {
                                                  href:
                                                    "/create?scan_id=" +
                                                    scan.scan_id,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-redo icon-mobile",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          { staticClass: "nav-item col-4" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "nav-link-mobile btn btn-link text-dark",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.prompt(
                                                      scan.scan_id,
                                                      "delete"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-trash icon-mobile",
                                                  attrs: {
                                                    "aria-hidden": "true",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("div", { staticClass: "actions col-4" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "text-info btn btn-link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.prompt(
                                              scan.scan_id,
                                              "cancel"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-times-circle",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                        _vm._v(
                                          "\n                                Cancel\n                            "
                                        ),
                                      ]
                                    ),
                                  ]),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                }),
                0
              ),
          _vm._v(" "),
          (_vm.$mq === "desktop" || _vm.$mq === "laptop") && _vm.risk_reports
            ? _c(
                "table",
                {
                  class: [
                    "scan-overview",
                    "risk-report",
                    (_vm.$mq === "desktop" || _vm.$mq === "laptop") &&
                      _vm.isLoading &&
                      "table-loading",
                  ],
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._l(_vm.risk_reports, function (risk_report) {
                    return _c("tbody", { key: risk_report }, [
                      _c(
                        "tr",
                        {
                          staticClass: "normal",
                          class: { unpublished: !risk_report.finished_at },
                        },
                        [
                          _c("td", { staticClass: "name" }, [
                            risk_report.finished_at
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "font-weight-bold",
                                    attrs: {
                                      href:
                                        _vm.risk_reports_page_url +
                                        risk_report.risk_report_id,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(risk_report.company_name) +
                                        "\n                        "
                                    ),
                                  ]
                                )
                              : _c("strong", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(risk_report.company_name) +
                                      "\n                        "
                                  ),
                                ]),
                          ]),
                          _vm._v(" "),
                          risk_report.finished_at
                            ? _c("td", { staticClass: "status" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        _vm.risk_reports_page_url +
                                        risk_report.risk_report_id,
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "nowrap" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("niceDate")(
                                            risk_report.finished_at
                                          )
                                        ) + " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c(
                                "td",
                                {
                                  staticClass:
                                    "status-processing text-info unpublished",
                                  attrs: {
                                    title: _vm._f("niceStarted")(
                                      risk_report.started
                                    ),
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-clock",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    "\n                        Generating Report\n                    "
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          risk_report.finished_at
                            ? _c("td", { staticClass: "report" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "row",
                                    attrs: {
                                      href:
                                        _vm.risk_reports_page_url +
                                        risk_report.risk_report_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-6 ips text-center",
                                        attrs: {
                                          title:
                                            risk_report.num_ips +
                                            " IPs & domains",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("niceNumber")(
                                                risk_report.num_ips
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-6 minor text-center",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("niceNumber")(
                                                risk_report.overall_maturity
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _c("td", { staticClass: "report-processing" }, [
                                _c("div", { staticClass: "d-flex" }),
                              ]),
                          _vm._v(" "),
                          risk_report.finished_at
                            ? _c("td", { staticClass: "actions" }, [
                                _c("ul", { staticClass: "nav" }, [
                                  _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link text-dark",
                                        attrs: {
                                          href:
                                            "/downloads/risk_report?risk_report_id=" +
                                            risk_report.risk_report_id,
                                          role: "button",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-download",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                        _vm._v(
                                          "\n                                    Download .pdf\n                                "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ])
                            : _c("td", { staticClass: "actions" }),
                        ]
                      ),
                    ])
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("modals-global", {
            attrs: {
              modalState: _vm.modalState,
              error_message: _vm.error_message,
              success_message: _vm.success_message,
            },
            on: { updateModal: _vm.updateModal },
          }),
          _vm._v(" "),
          _c("modals-cancel-delete", {
            attrs: { modalState: _vm.modalState, scan_id: _vm.selectedScan },
            on: {
              updateModal: _vm.updateModal,
              cancelScan: _vm.cancelScan,
              deleteScan: _vm.deleteScan,
            },
          }),
          _vm._v(" "),
          _c("modals-jira", {
            attrs: { modalState: _vm.modalState, scan_id: _vm.selectedScan },
            on: { updateModal: _vm.updateModal },
          }),
          _vm._v(" "),
          _c("modals-home", {
            attrs: { modalState: _vm.modalState },
            on: { updateModal: _vm.updateModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "loading" }, [
      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", { staticClass: "header" }, [
        _c("th", { attrs: { scope: "col", colspan: "2" } }, [
          _vm._v("Scan label"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right", attrs: { scope: "col" } }, [
          _vm._v("Revision"),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _c("div", { staticClass: "stats-header severities" }, [
            _c("div"),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n                                    Severities\n                                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stats-header" }, [
            _c("div", [
              _vm._v(
                "\n                                    IPs\n                                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "critical" }, [
              _vm._v(
                "\n                                    Critical\n                                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "high" }, [
              _vm._v(
                "\n                                    High\n                                "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "medium" }, [
              _vm._v(
                "\n                                    Medium\n                                "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "actions", attrs: { scope: "col" } }, [
          _vm._v("Actions"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "row headers", staticStyle: { "text-align": "center" } },
      [
        _c("div", { staticClass: "col-2" }, [
          _vm._v("\n                        Rev\n                    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _vm._v("\n                        Issues\n                    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-4" }, [
          _vm._v("\n                        Actions\n                    "),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Company Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Report")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6 text-center" }, [
              _vm._v(
                "\n                                IPs\n                            "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _vm._v(
                "\n                                Overall\n                            "
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Actions")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }